import {axiosGet} from "../../application/helpers/AxiosHelper";
import {GENERAL_SETTINGS} from "../../application/config/ApiUrl";

export default {
    state: () => ({
        settings: window.settings
    }),
    mutations: {
        SET_SETTINGS: (state, payloads) => state.settings = payloads,
    },
    actions: {
        getSettings(context) {
            axiosGet(GENERAL_SETTINGS).then(({data}) => {
                context.commit('SET_SETTINGS', data);
            });
        },
    },
    getters: {
        settings: state => state.settings
    }
}
